import { ACTION_CONTEXT_KEY } from "data/util/ContextedReduceStore";

export const actionsBlacklist = [
    "global-define/",
    "global-load/",
    "over/",
    "development/"
];

const actionToConsoleBuilder = handler => (action, ...extraArgs) => {
    // primitive string or typedAction
    const actionName = action.type.toString();
    if (actionsBlacklist.some(it => actionName.indexOf(it) >= 0)) {
        return false; // blacklisted...
    }
    const args = ["FLUX>", actionName];
    // so we can delete top-level key(s)
    action = {...action};
    delete action.type;
    if (action.hasOwnProperty(ACTION_CONTEXT_KEY)) {
        args.push(action[ACTION_CONTEXT_KEY]);
        delete action[ACTION_CONTEXT_KEY];
    }
    args.push(action);
    args.push(...extraArgs);
    console[handler].apply(undefined, args);
    return true;
};

export const logActionToConsole = actionToConsoleBuilder("log");
export const actionGroupInConsole = actionToConsoleBuilder("group");



// WEBPACK FOOTER //
// ./app/data/dev/logActionToConsole.js